demo:
  chrome:
    share: Partager
